import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

interface UIState {
  isMenuOpen: boolean
  activeSection: string
  showAllProjects: boolean
  activeFAQ: number | null
}

const initialState: UIState = {
  isMenuOpen: false,
  activeSection: "hero",
  showAllProjects: false,
  activeFAQ: null,
}

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    toggleMenu: (state) => {
      state.isMenuOpen = !state.isMenuOpen
    },
    setActiveSection: (state, action: PayloadAction<string>) => {
      state.activeSection = action.payload
    },
    toggleShowAllProjects: (state) => {
      state.showAllProjects = !state.showAllProjects
    },
    setActiveFAQ: (state, action: PayloadAction<number | null>) => {
      state.activeFAQ = action.payload
    },
  },
})

export const { toggleMenu, setActiveSection, toggleShowAllProjects, setActiveFAQ } = uiSlice.actions
export default uiSlice.reducer
